// Return a new Array with the data from csv file result (FileReader)
export default function (file) {
  const delimiter = ",";
  const listDelimiter = "-";

  const headers = file.slice(0, file.indexOf("\n")).split(delimiter).map(e => e.replace(/\s/g, ''));
  const rows = file.slice(file.indexOf("\n") + 1).split("\n").filter(el => el !== '');

  if (!headers.includes('name', 'description', 'tags', 'status', 'domains')) {
    return false;
  }

  const arr = rows.map((row) => {
    const values = row.split(delimiter);
    const el = headers.reduce((object,header,index) => {
      var val = cleanUpValues(values[index]);
      // Build the tags and targert lists
      if (header === 'tags' || header === 'domains'){
        val = val.split(listDelimiter);
      }
      object[header] = val;

      return object;
    }, {});
    return el;
  })

  return arr
}

function cleanUpValues(str){
  return  str.replace("\r", "").replace("\t", "")
}



// WEBPACK FOOTER //
// ./src/common/utils/csvToArray.js